import React from "react";
import { AuthValues } from '../types'

const defaultValue: AuthValues = {
  routes: [],
  authorizationsState: 'loading',
  retryAuthorizations: () => null,
}

const AuthContext = React.createContext(defaultValue);

export default AuthContext;
